export const CATEGORY_PHOTOS = {
  lavadoras: [
    { src: "/assets/lavadora-liquidacion.jpg", label: "Lavadora Whirlpool en liquidación" },
    { src: "/assets/lavadora-whirlpool-frontal.jpg", label: "Lavadora Whirlpool carga frontal" },
    { src: "/assets/lavadora-frigidaire.jpg", label: "Lavadora Frigidaire" },
    { src: "/assets/lavadora-maytag.jpg", label: "Lavadora Maytag Centennial" },
    { src: "/assets/lavadoras-pareja.jpg", label: "Lavadoras en exhibición" },
    { src: "/assets/juego-lavanderia.jpg", label: "Juego de lavandería" },
    { src: "/assets/showroom-pasillo.jpg", label: "Pasillo de lavadoras" },
    { src: "/assets/lavadoras-pasillo2.jpg", label: "Lavadoras de carga frontal" },
    { src: "/assets/pareja-lavaseca.jpg", label: "Lavadora y secadora" },
  ],
  refrigeradoras: [
    { src: "/assets/refri-negra.jpg", label: "Refrigeradora negra" },
    { src: "/assets/refri-samsung-fd.jpg", label: "Refrigeradora Samsung French Door" },
    { src: "/assets/refri-samsung-33.jpg", label: "Refrigeradora Samsung con pantalla" },
    { src: "/assets/refris-blancas.jpg", label: "Refrigeradoras side by side" },
    { src: "/assets/refris-fila.jpg", label: "Refrigeradoras KitchenAid y más" },
    { src: "/assets/refris-frenchdoor.jpg", label: "Refrigeradoras French Door" },
    { src: "/assets/refris-pasillo.jpg", label: "Pasillo de refrigeradoras" },
  ],
  secadoras: [
    { src: "/assets/secadoras.jpg", label: "Secadoras" },
    { src: "/assets/secadoras-grupo.jpg", label: "Secadoras en exhibición" },
    { src: "/assets/secadoras-2.jpg", label: "Secadoras con precios de liquidación" },
    { src: "/assets/juego-lavanderia.jpg", label: "Juego de lavandería" },
    { src: "/assets/pareja-lavaseca.jpg", label: "Secadora y lavadora" },
  ],
  "centros-de-lavado": [{ src: "/assets/centros-lavado.jpg", label: "Centros de lavado Whirlpool" }],
  estufas: [
    { src: "/assets/estufas.jpg", label: "Estufas a gas y eléctricas" },
    { src: "/assets/estufa-frigidaire.jpg", label: "Estufa Frigidaire 5 quemadores" },
    { src: "/assets/estufa-maytag.jpg", label: "Estufa Maytag" },
    { src: "/assets/estufa-midea.jpg", label: "Estufa eléctrica y refrigeradora Midea" },
    { src: "/assets/estufa-refri-lg.jpg", label: "Estufa Frigidaire y refrigeradora LG" },
  ],
  "congeladores-verticales": [
    { src: "/assets/congelador-kenmore.jpg", label: "Congelador vertical Kenmore" },
    { src: "/assets/congelador-blanco.jpg", label: "Congelador vertical" },
  ],
  "camaras-de-enfriamiento": [
    { src: "/assets/camaras.jpg", label: "Cámara de enfriamiento de doble puerta" },
    { src: "/assets/camaras-2.jpg", label: "Cámara de enfriamiento con iluminación LED" },
  ],
};

export const SHOWROOM_PHOTOS = [
  { src: "/assets/showroom-pared.jpg", label: "Showroom — pared principal" },
  { src: "/assets/showroom-muro.jpg", label: "Showroom — muro iluminado" },
  { src: "/assets/refris-fila.jpg", label: "Showroom — refrigeradoras" },
  { src: "/assets/showroom-pasillo.jpg", label: "Showroom — pasillo principal" },
  { src: "/assets/fachada-10calle.jpg", label: "Sucursal 10 calle" },
  { src: "/assets/fachada-7calle.jpg", label: "Sucursal 7 calle" },
];
